if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			/* Optional */
			loadProductFirst: false,
            // Filter Mobile
    		filterTreeMobileStyle: 'style3', // 'style1', style2', 'style2-fullwidth','style3', 'style3-fullwidth'
		},
	};
}

(function () {
	// Add this
	BoostPFS.inject(this); // Add this

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {

		if (!data) data = this.data; // Add this line
		if (!index) index = this.index; // Add this line
		if (!totalProduct) totalProduct = this.totalProduct;

      //console.log('--- Metafields ---');
      //console.log('Title: ', data.title);
      //console.log('Metafield: ', Utils.getProductMetafield(data, 'Auction', 'current_bid'));
      //console.log('-----')
		var soldOut = !data.available;
		var onSale = data.compare_at_price_min > data.price_min;
		var priceVaries = data.price_min != data.price_max;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		itemHtml = itemHtml.replace(/{{gridItemWidth}}/g, boostPFSConfig.custom.grid_item_width);

		// Add class
		// Add Badges
		var itemBadgesHtml = "";
		if (boostPFSConfig.custom.enable_badges) {
			if(onSale && data.available) {
				itemBadgesHtml += boostPFSTemplate.saleLabelHtml.replace(/{{onSaleLabel}}/g, boostPFSConfig.label.on_sale);
			} else if(!data.available) {
				itemBadgesHtml += boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutLabel}}/g, boostPFSConfig.label.sold_out);
			}
		}
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.product_card_vendor ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor): "";
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
		// Add price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, boostPFSConfig.custom.product_card_price ? buildPrice(data, onSale, priceVaries) : '');

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewsHtml = boostPFSConfig.custom.show_reviews ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>': "";
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
		}

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Quick view
		itemHtml = itemHtml.replace(/{{itemQuickview}}/g, buildQuickView(data, soldOut));
        
        // Add Watchlist
        var itemWatchListHtml = '';
        var customer_count = Utils.getProductMetafield(data, 'wk_shopify_wishlist', 'customer_count');
        var num_watchers = (parseInt(customer_count, 10) || 0);
        //console.log('Num Watchers', num_watchers)
        //console.log(data.tags, data.tags.includes('on_auction'))
        //Add SWAU Custom Auction View
        itemWatchListHtml += '<div class="swau-custom-auction-collection" data-prod="{{itemId}}"></div>';
        //Add link
        itemWatchListHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid-view-item-link"></a>'
        if (data.tags.includes('on_auction')) {
          itemWatchListHtml += '<div class="watchlistIcon">';
          itemWatchListHtml += '<div data-cust="{{customerId}}" data-prod="{{itemId}}" class="pw-category"></div>';
              itemWatchListHtml += '<div class="numWatchersText">' + num_watchers + '</div>';

            //itemWatchListHtml += '<div data-cust="{{customerId}}" data-prod="{{itemId}}" class="pw-category"></div>';
        }
		else if(data.tags.includes('Vault Collection')) {
			itemWatchListHtml+= `<div class="swau-vault-item-collection" data-prod="{{itemId}}" data-variant="${data.variants[0].id}" data-price="${data.price_min}" data-customer="{{customerId}}"></div>`;
		}
        itemHtml = itemHtml.replace(/{{itemWatchlist}}/g, itemWatchListHtml);
      
        // Add custom Id
        var customerId = boostPFSThemeConfig.custom.customerId || '';
		itemHtml = itemHtml.replace(/{{customerId}}/g, customerId);
      
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, boostPFSConfig.custom.product_card_title ? data.title : '');
		itemHtml = itemHtml.replace(/{{itemUrl}}/g,Utils.buildProductItemUrlWithVariant(data));

		return itemHtml;
	};

	function checkCropSetting(){
		var crop_setting = boostPFSThemeConfig.custom.crop_setting;
		var image_crop;
		switch (crop_setting) {
		case "square":
			image_crop = "aspect-ratio--square"
			break;
		case "tall":
			image_crop = "aspect-ratio--tall"
			break;
		case "wide":
		image_crop = "aspect-ratio--wide"
		break;
		default:
		image_crop = "";
		}
		return image_crop;
	}
	function buildImages(data) {
		var images = data.images_info;
		var html = "";
		if (boostPFSConfig.custom.hover_effect) {
			if (images.length > 1) {
				html += '<div class="reveal">';
				html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
			  html += `<div class="${checkCropSetting() && `aspect-ratio ${checkCropSetting()}`}">`;
				html += '<img src="' + Utils.optimizeImage(images[0]["src"], "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
				html += "</div>";
			  html += `<div class="hidden ${checkCropSetting() && `aspect-ratio ${checkCropSetting()}`}">`;
				html +='<img src="' + Utils.optimizeImage(images[1]["src"], "760x") + '" alt="{{itemTitle}}" class="img-responsive" />';
				html += "</div>";
				html += "</a>";
				html += "</div>";
			} else {
				html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
			   html += `<div class="${checkCropSetting() && `aspect-ratio ${checkCropSetting()}`}">`;
        		html += '<img src="' + Utils.getFeaturedImage(images, "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
				html += "</div>";
				html += "</a>";
			}
		} else {
			html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
			html += `<div class="${checkCropSetting() && `aspect-ratio ${checkCropSetting()}`}">`;
			html += '<img src="' + Utils.getFeaturedImage(images, "760x") + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
			html += "</div>";
			html += "</a>";
		}
		return html;
	}

	function buildQuickView(data, soldOut) {
    var html = "";
    if (boostPFSConfig.custom.product_card_button) {
			html += '<div class="quick-add-wrapper ' + (data.variants.length == 1 ? 'is-singular' : '') + '" data-block-type="product_card_button">';
			if (soldOut) {
				html += '<div class="quick-add-wrapper">' +
									'<a class="sold-out-button" tabIndex="0" href="{{itemUrl}}">' + boostPFSConfig.label.sold_out + '</a>' +
								'</div>';
			} else {
				if (data.variants.length > 1) {
					html += '<div class="quick-add-wrapper">' +
										'<a class="quick-add-button-variants" tabIndex="0" href="{{itemUrl}}">' + boostPFSConfig.label.view_options + '</a>' +
									'</div>';
				} else {
					html += '<form method="post" action="/cart/add" id="CollectionAddToCartForm" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">' +
												'<input type="hidden" name="form_type" value="product">' +
												'<input type="hidden" name="utf8" value="✓">' +
												'<input type="hidden" name="id" value="' + data.variants[0].id + '"/>' +
												'<button class="quick-add-button" type="submit" tabindex="0">' +
													boostPFSConfig.label.add_to_cart +
										'</button>' +
									'</form>';
				}
			}
			html += '</div>';
    }
    return html;
}

	function buildPrice(data, onSale, priceVaries) {
		var html = '';
        if (data.tags.includes("on_auction") || data.tags.includes("wk_end_auction") || data.tags.includes("upcoming_auction")) {
          return '';
        }
		if (onSale) {
			if (priceVaries) {
				html += boostPFSConfig.label.sale_from_price.replace( /{{ price }}/g, '<span class="money line--through">' + Utils.formatMoney(data.price_max || data.compare_at_price_max) + '</span>');
				if (boostPFSThemeConfig.custom.show_discount == "percentage"){
					html += '<span class="money sale-price"> -'+ data.percent_sale_min +'%</span>';
				}
				else if(boostPFSThemeConfig.custom.show_discount == "value"){
					html += '<span class="money sale-price"> -'+ Utils.formatMoney(data.price_max - data.price_min) +'</span>';
				}
       			html += `<span class="money ${boostPFSThemeConfig.custom.show_discount != "hide" && "sale-price--with-discount"}"> ${Utils.formatMoney(data.price_min)}</span>`;
			} else {
				html += '<span class="product-grid--compare-price">' + Utils.formatMoney(data.compare_at_price_min) + "</span>";
				html += ' <span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
			}
		} else {
			if (priceVaries) {
				html += ' <span class="product-grid--from-wrapper">' + boostPFSConfig.label.from_price + '</span> <span class="money">' + Utils.formatMoney(data.price_min) + "</span>";
			} else {
				html += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
			}
		}
		return html;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift("...");
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push("...");
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = "";
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == "...") {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = "";
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + "</option>";
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingLabel}}/g, Labels.sorting)
				html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}
		return '';
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;

        // Run custom code of the client === [auction app] 
        try {
           if (jQ(".wk-category-auction").length > 0) {
              const div = document.querySelector('.pa-timer');
              var products = "";
              var cust_id = jQ(".wk-category-auction").attr("cust-id");
              jQ(".wk-category-auction").each(function() {
                 var product = parseInt(jQ(this).data('prod'));
                 if (!isNaN(product) && product > 0) {
                    products += product + ",";
                 } else {
                    products = false;
                    return false;
                 }
              });
              if (products && spcObj) {
                 spcObj.showProductAuctions(products, cust_id)
              }
           }

           if ($('body').find('.pw-category').length > 0) {
              var products = '';
              var customer = $('.pw-category').data('cust');

              $('.pw-category').each(function() {
                 var product = parseInt($(this).data('prod'));
                 if (!isNaN(product) && product > 0)
                    products += product + ',';
                 else {
                    products = false;
                    return false;
                 }
              });
              if (products && pwObj) {
                 if (typeof pwObj !== "undefined") {
                    pwObj.showWishlistIcon(products, customer);
                 }
              }
           }
        } catch (error) {
           console.log(error);
        }
      
        // End custom code
      
		// Center no result message
		if(jQ('.boost-pfs-filter-tree').css('display') === 'none') {
			if(!Utils.isSearchPage()) jQ('.collection-filtering-section').css('display', 'none');
			jQ('.large--three-quarters').removeClass('large--three-quarters').addClass('large--four-quarters');
		 } else {
			if(!Utils.isSearchPage()) jQ('.collection-filtering-section').css('display', '')
			jQ('.large--four-quarters').removeClass('large--four-quarters').addClass('large--three-quarters');
		}

		resetStyleCollectionImage();

		buildTheme();
	};

	// Build additional elements
	Filter.prototype.afterRender = function (data, eventType) {
		if(Utils.isMobile()) {
			resetStyleCollectionImage();
		}
        var resultCounter = '';
		if (this.data.total_product > 1) {
			resultCounter = 'Showing {{ count }} lots';
		} else {
			resultCounter = 'Showing {{ count }} lot';
		}
        jQ('.boost-pfs-filter-total-product').html(resultCounter.replace(/{{ count }}/g, '<strong>' + Utils.stripHtml(this.data.total_product) + '</strong>'));
	};

	// Reset inline style of collection image after clicking pagination or filter to adapt parallax effect
	function resetStyleCollectionImage() {
		jQ('#rellax--collection-image').attr('style', '');
	}

	function buildTheme() {
		// Call theme function
		if (window.wetheme && typeof wetheme.onLoadAll == "function") {
			wetheme.onLoadAll({});
      if (document.querySelector('.site-nav__link.js-drawer-open-right-link') !== null) {
        document.querySelector('.site-nav__link.js-drawer-open-right-link').addEventListener("click",function (e) {
          e.preventDefault();
          wetheme.toggleRightDrawer("cart");
        });
      }
		}

		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}

		if(Shopify.PaymentButton && typeof Shopify.PaymentButton.init === "function" ) {
			Shopify.PaymentButton.init();
		}

		if (boostPFSConfig.custom.show_multiple_currencies) {
			convertCurrencies();
		}
	}

	Filter.prototype.stickyFilterDesktop = function () {
		var $filterTree = jQ(Selector.stickyElementDesktop);
		var filterTreeVerticalStyle = Settings.getSettingValue('general.filterTreeVerticalStyle');
		var $stickyFilterTreeDesktopButtonWrapper = jQ(Selector.stickyFilterTreeDesktopButtonWrapper);
		var $filterTreeHorizontalWrapper = jQ(Selector.filterTreeHorizontalWrapper);
		var avoidStickyHeader = Selector.avoidStickyHeader;
		var filterTreeWrapper = jQ(Selector.filterTreeWrapper).length > 0 ? Selector.filterTreeWrapper : Selector.endStickyDesktop;
		if ($stickyFilterTreeDesktopButtonWrapper.length > 0) {
			avoidStickyHeader = jQ(Selector.avoidStickyHeader).length > 0 ? Selector.avoidStickyHeader + ',' + Selector.stickyFilterTreeDesktopButtonWrapper : Selector.stickyFilterTreeDesktopButtonWrapper;
		}

		var avoidStickyHeaderElements = jQ(avoidStickyHeader);

		/**
		* @description Don't sticky the default headers of theme
		*/
		avoidStickyHeaderElements.each((i, elm) => {
			if (getComputedStyle(elm).position == 'sticky') {
				elm.style.position = 'inherit';
			}
		});

		var filterTreeHorizontal = $filterTree.hasClass(Class.filterTreeHorizontal) ? true : false;

		if ((filterTreeVerticalStyle === 'style-off-canvas' || filterTreeVerticalStyle === 'style-expand' || filterTreeHorizontal)) {
			// Sticky for Filter Tree Desktop Button Wrapper
			$stickyFilterTreeDesktopButtonWrapper.each((index, ele) => {
				Utils.sticky(jQ(ele), Selector.endStickyDesktop, Selector.avoidStickyHeader);
				$stickyFilterTreeDesktopButtonWrapper.css({maxWidth: jQ(filterTreeWrapper).width() + 'px'});
			});

			// Sticky for Horizontal Wrapper Style Expand
			$filterTreeHorizontalWrapper.each((index, ele) => {
				Utils.sticky(jQ(ele), Selector.endStickyDesktop, avoidStickyHeader);
				$filterTree.css({maxWidth: jQ(filterTreeWrapper).width() + 'px'});
			});
		}
		// Stick filter tree
		$filterTree.each((index, ele) => {
			if (($stickyFilterTreeDesktopButtonWrapper.length < 1 || filterTreeVerticalStyle === 'style-expand')) {
				Utils.sticky(jQ(ele), Selector.endStickyDesktop, avoidStickyHeader);
				if (filterTreeHorizontal) {
					$filterTree.css({maxWidth: jQ(filterTreeWrapper).width() + 'px'});
				}
			}
		});
	}

    FilterApi.beforeCall = function(eventType, eventInfo) { 
      Globals.queryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
      Globals.queryParams.currency_rate = Shopify.currency.rate;
      Globals.queryParams.return_all_currency_fields = false;
    }


})();
